
//******************Exchange Rate Server Calls******************;

import {DeleteExchangeRatesActions} from './DeleteExchangeRatesConstants';
import store from '../../../Store/store'
import {ROOT_URL,getCookie} from '../../../Config/Config';
import {failure_messages} from "Messages"

export const DeleteExchangeRatesServer = {
  //  handleDeleteExchangeRates:handleDeleteExchangeRates,
  handleDeleteExchangeRates:handleDeleteExchangeRates,
  //  updateDeleteExchangeRates:updateDeleteExchangeRates
};

//******************Insert DeleteExchangeRatess******************;

function handleDeleteExchangeRates(data){
      const request=fetch(ROOT_URL+'/api/exchangeRate/handleDeleteExchangeRates', {
          method: 'POST',
          mode: 'cors',
          headers: { 
            'authorization':getCookie("admin_token"),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
          }).then((response)=>{
           response.json().then(response=>{
             if(response.status == "200"){
            store.dispatch({type:DeleteExchangeRatesActions.DeleteExchangeRates_DELETE.SUCCESS,payload:data, message:response.message});
            return ;
            }else
            {
              store.dispatch({type:DeleteExchangeRatesActions.DeleteExchangeRates_DELETE.FAILED, error:response.error });
              return ;
              }    
           });
          }).catch((error) => {
           store.dispatch({type:DeleteExchangeRatesActions.DeleteExchangeRates_DELETE.FAILED, error:failure_messages.ExchangeRateDeleteError});
            })
      return {type:DeleteExchangeRatesActions.DeleteExchangeRates_DELETE.LOADING}

};
  
//******************Get DeleteExchangeRatess******************;


//******************Update DeleteExchangeRates******************;

  
// function handleDeleteExchangeRates(){
//       const request=fetch(ROOT_URL+'/api/exchangeRate/getExchangeRate/', {
//           method: 'GET',
//           mode: 'cors',
//           headers: {'Content-Type':'application/json'},
//          // body: JSON.stringify(data)
//           }).then((response)=>{
//             response.json().then(response=>{
//               if(response.status == "200"){
//                 console.log(response)
//                 if(response.DeleteExchangeRates.length>0)
//              store.dispatch({type:DeleteExchangeRatesActions.DeleteExchangeRates_DELETE.SUCCESS,payload:response.DeleteExchangeRates});
//              else
//              store.dispatch({type:DeleteExchangeRatesActions.DeleteExchangeRates_DELETE.NEW});
             
//              return ;
//              }else
//              {
//                store.dispatch({type:DeleteExchangeRatesActions.DeleteExchangeRates_DELETE.FAILED});
//                return ;
//                }    
//             });
//            }).catch((error) => {
//             store.dispatch({type:DeleteExchangeRatesActions.DeleteExchangeRates_DELETE.FAILED});
//           })
//        return {type:DeleteExchangeRatesActions.DeleteExchangeRates_DELETE.LOADING}
 
//     };
  
// function updateDeleteExchangeRates(data){
//   const request=fetch(ROOT_URL+'/api/exchangeRate/BulkUpdateExchangeRate', {
//     method: 'Post',
//     mode: 'cors',
//     headers: {'Content-Type':'application/json'},
//     body: JSON.stringify(data)
//     }).then((response)=>{
//      response.json().then(response=>{
//        if(response.status == "200"){
//          console.log(response)
//       store.dispatch({type:DeleteExchangeRatesActions.DeleteExchangeRates_DELETE.SUCCESS});
//       return ;
//       }else
//       {
//         store.dispatch({type:DeleteExchangeRatesActions.DeleteExchangeRates_DELETE.FAILED});
//         return ;
//         }    
//      });
//     }).catch((error) => {
//       store.dispatch({type:DeleteExchangeRatesActions.DeleteExchangeRates_DELETE.FAILED});
//     })
// return {type:DeleteExchangeRatesActions.DeleteExchangeRates_DELETE.LOADING}

// };
